import { FC, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import {
	CONTENT_FIELDS,
	getContentFieldValue,
} from '../../../lib/helpers/content.helper';
import { IEntityContentField } from '../../../lib/interfaces/Common';
import ContentTitleWithIcon from '../../Simple/ContentTitle/ContentTitleWithIcon';
import { FIELD_TYPES } from '../../Form/form.utils';
import ContentRenderer from '../Content/ContentRenderer';
import GuruImg from '../../../static/assets/guru3.png';
import './VideoReference.scss';

type VideoReferenceProps = {
	field: IEntityContentField;
};

const VideoReference: FC<VideoReferenceProps> = ({ field }) => {
	const { reference } = field;
	const { t, i18n } = useTranslation();
	const [displayOverlay, setDisplayOverlay] = useState<boolean>(true);
	const currentLanguage: string = i18n.language;
	const title =
		reference?.content &&
		getContentFieldValue({
			entityContent: reference.content,
			field: CONTENT_FIELDS.NAME,
			language: currentLanguage,
		});
	const posterUrl =
		reference?.content &&
		getContentFieldValue({
			entityContent: reference.content,
			field: CONTENT_FIELDS.POSTER_URL,
			language: currentLanguage,
		});
	const videoUrl =
		reference?.content &&
		getContentFieldValue({
			entityContent: reference.content,
			field: CONTENT_FIELDS.VIDEO_URL,
			language: currentLanguage,
		});

	const vidRef = useRef<HTMLVideoElement>(null);
	const handleVideoClick = () => {
		vidRef?.current?.play();
		setDisplayOverlay(false);
	};

	return (
		<div>
			{!displayOverlay && (
				<ContentTitleWithIcon
					id={field.id}
					content={title || t('video')}
					icon={PlayCircleOutlineIcon}
				/>
			)}
			{reference?.content[currentLanguage]?.map((block: IEntityContentField) => {
				if (block.type === FIELD_TYPES.RICH_EDITOR) {
					return <ContentRenderer html={block.content} key={block.name} />;
				}
			})}
			{videoUrl && (
				<div className="VideoReference" id={field.id}>
					{displayOverlay && (
						<div className="video-overlay" onClick={handleVideoClick}>
							<div className="title">{title}</div>
							<div className="guru-image">
								<img src={GuruImg} alt="" />
							</div>
							<div className="play-button">
								<PlayCircleIcon sx={{ color: '#fff', fontSize: '80px' }} />
							</div>
						</div>
					)}
					<video
						style={{ maxWidth: '800px', width: '100%' }}
						controls
						controlsList="nodownload"
						poster={posterUrl || null}
						key={reference.id}
						ref={vidRef}
					>
						<source key={reference.id} src={videoUrl} type="video/mp4" />
					</video>
				</div>
			)}
		</div>
	);
};

export default VideoReference;
